// extracted by mini-css-extract-plugin
module.exports = {"section":"Partners_section__13BTZ","client":"Partners_client__HEQ49"};